import { render, staticRenderFns } from "./SensitiveWord.vue?vue&type=template&id=375c4684&"
import script from "./SensitiveWord.vue?vue&type=script&lang=js&"
export * from "./SensitiveWord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports